var render = function () {
  var _class, _class2, _class3, _domProps, _class4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_vm.type === 'checkbox' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.internalValue,
      expression: "internalValue"
    }],
    ref: "capustaInput",
    class: (_class = {}, _class[_vm.$style.field] = true, _class[_vm.$style.invalid] = _vm.isInvalid, _class[_vm.$style.spacing] = _vm.$slots.hasOwnProperty('link'), _class),
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": "checkbox"
    },
    domProps: {
      "value": _vm.value,
      "checked": Array.isArray(_vm.internalValue) ? _vm._i(_vm.internalValue, _vm.value) > -1 : _vm.internalValue
    },
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus,
      "change": function change($event) {
        var $$a = _vm.internalValue,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;

        if (Array.isArray($$a)) {
          var $$v = _vm.value,
              $$i = _vm._i($$a, $$v);

          if ($$el.checked) {
            $$i < 0 && (_vm.internalValue = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.internalValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.internalValue = $$c;
        }
      }
    }
  }) : _vm.type === 'radio' ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.internalValue,
      expression: "internalValue"
    }],
    ref: "capustaInput",
    class: (_class2 = {}, _class2[_vm.$style.field] = true, _class2[_vm.$style.invalid] = _vm.isInvalid, _class2[_vm.$style.spacing] = _vm.$slots.hasOwnProperty('link'), _class2),
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": "radio"
    },
    domProps: {
      "value": _vm.value,
      "checked": _vm._q(_vm.internalValue, _vm.value)
    },
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus,
      "change": function change($event) {
        _vm.internalValue = _vm.value;
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.internalValue,
      expression: "internalValue"
    }],
    ref: "capustaInput",
    class: (_class3 = {}, _class3[_vm.$style.field] = true, _class3[_vm.$style.invalid] = _vm.isInvalid, _class3[_vm.$style.spacing] = _vm.$slots.hasOwnProperty('link'), _class3),
    attrs: {
      "id": _vm.inputId,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "type": _vm.type
    },
    domProps: (_domProps = {
      "value": _vm.value
    }, _domProps["value"] = _vm.internalValue, _domProps),
    on: {
      "blur": _vm.handleBlur,
      "focus": _vm.handleFocus,
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.internalValue = $event.target.value;
      }
    }
  }), _c('label', {
    class: (_class4 = {}, _class4[_vm.$style.label] = true, _class4[_vm.$style.spacing] = _vm.isInvalid || _vm.disabled, _class4),
    attrs: {
      "for": _vm.inputId
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('div', {
    class: _vm.$style.attachmentContainer
  }, [_c('div', {
    class: _vm.$style.attachmentPosition
  }, [_c('div', {
    class: _vm.$style.icons
  }, [_vm.disabled ? _c('div', {
    class: _vm.$style.lockCircleIcon
  }, [_c('lock-circle-icon')], 1) : _vm._e(), _vm.isInvalid ? _c('div', {
    class: _vm.$style.alertCircleIcon
  }, [_c('alert-circle-icon')], 1) : _vm._e()]), _vm.$slots.hasOwnProperty('link') ? _c('div', {
    class: _vm.$style.link
  }, [_vm._t("link")], 2) : _vm._e()]), _vm.$slots.hasOwnProperty('composite') || _vm.$scopedSlots.hasOwnProperty('composite') ? _c('div', {
    class: _vm.$style.attachmentComposite
  }, [_vm._t("composite", null, {
    "focused": _vm.focused
  })], 2) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }